import api from "@/lib/api";
import { Upload } from "lucide-react";
import { toast } from "sonner";

export default function LogoUploader({ client, onUploaded }) {
  const upload = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!f.type.startsWith("image/")) {
      toast.error("Please upload an image");
      return;
    }
    try {
      const fd = new FormData();
      fd.append("file", f);
      const r = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.patch(`/clients/${client.id}`, { logo_file_id: r.data.id });
      toast.success("Logo updated");
      onUploaded();
    } catch { toast.error("Upload failed"); }
  };
  return (
    <label className="cursor-pointer inline-flex items-center gap-1.5 px-3 py-2 border border-slate-200 rounded-sm text-xs hover:border-[#0a2540]" data-testid="btn-upload-logo">
      <Upload size={12} /> {client.logo_file_id ? "Change logo" : "Add logo"}
      <input type="file" accept="image/*" className="hidden" onChange={upload} />
    </label>
  );
}
